const CHARGE_STATUS_LABELS = {
  created: 'Created',
  pending: 'Pending',
  unpaid: 'Unpaid',
  partially_paid: 'Partially paid',
  paid: 'Paid',
  canceled: 'Canceled',
  failed: 'Failed',
  refunded: 'Refunded',
};

export default function getChargeStatusLabel(status) {
  return CHARGE_STATUS_LABELS[status] || 'Unknown';
}
